export enum PaymentMethods {
  STRIPE,
  PAYPAL,
  APPLE_PAY,
  GOOGLE_PAY,
}
